<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-b-modal.new-user size="sm" variant="primary"><i class="mdi mdi-plus"></i> New User</b-button>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(role)="data">
                {{ data.item.role.name }}
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">
                  <b-button
                    @click="openEdit(data.item)"
                    type="button"
                    class="btn-sm btn"
                    variant="primary"
                    :title="isOwnProfile(data.item) ? 'Edit your profile' : 'Edit this user'"
                  >
                    <i class="mdi mdi-square-edit-outline"></i>
                  </b-button>
                  <b-button
                    @click="openPasswordChange(data.item)"
                    type="button"
                    class="btn-sm btn"
                    variant="info"
                    :title="isOwnProfile(data.item) ? 'Change your password' : 'Set a new password for this user'"
                  >
                    <i class="mdi mdi-lock"></i>
                  </b-button>
                  <b-button
                    v-if="!isOwnProfile(data.item)"
                    @click="remove(data.item.id,data.item.full_name)"
                    type="button"
                    class="btn-sm btn"
                    variant="danger"
                    title="Deactivate this user"
                  >
                    <i class="mdi mdi-trash-can"></i>
                  </b-button>
                </div>
              </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-user" centered title="New System User" title-class="font-18" hide-footer>
      <form @submit.prevent="addUser">
        <div class="form-group mb-2">
          <label>Full Name</label>
          <input v-model="fullname" type="text" class="form-control" />
        </div>
        <div class="form-group mb-2">
          <label>Contact</label>
          <input v-model="contact" type="number" class="form-control" />
        </div>
        <div class="form-group mb-2">
          <label>Email Address</label>
          <input v-model="email" type="email" class="form-control" />
        </div>
        <div class="form-group mb-2">
          <label>Username</label> <span v-html="usernameerror"></span>
          <input v-model="username" type="text" @input="CheckUsername" class="form-control" />
        </div>
        <div class="form-group mb-2">
          <label>Password</label> <span v-html="passStrength"></span>
          <input v-model="password" type="password" @input="CheckPassword" class="form-control" />
        </div>
        <div class="form-group mb-2">
          <label>Role</label>
          <b-form-select v-model="role" :options="roles" class="mb-3 form-control" value-field="id" text-field="name"></b-form-select>
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-user')" >Close</b-button>
          <b-button type="submit" :disabled="btnuser || savingNewUser" class="btn ms-1 w-30" variant="primary" >
            <b-spinner v-if="savingNewUser" small class="align-middle me-1"></b-spinner>
            <i v-else class="fas fa-check-circle"></i>
            {{ savingNewUser ? 'Saving...' : 'Submit' }}
          </b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="edit-user" centered :title="isEditingSelf ? 'Update My Profile' : 'Edit System User'" title-class="font-14" hide-footer>
      <form @submit.prevent="editUser">
        <div class="form-group mb-2">
          <input v-model="id" type="hidden">
          <label>Full Name</label>
          <input v-model="fullname" type="text" class="form-control" :class="{ 'is-invalid': hasProfileError('fullname') }" />
          <small v-if="hasProfileError('fullname')" class="text-danger">{{ profileError('fullname') }}</small>
        </div>
        <div class="form-group mb-2">
          <label>Contact</label>
          <input v-model="contact" type="number" class="form-control" :class="{ 'is-invalid': hasProfileError('contact') }" />
          <small v-if="hasProfileError('contact')" class="text-danger">{{ profileError('contact') }}</small>
        </div>
        <div class="form-group mb-2">
          <label>Email Address</label>
          <input v-model="email" type="email" class="form-control" :class="{ 'is-invalid': hasProfileError('email') }" />
          <small v-if="hasProfileError('email')" class="text-danger">{{ profileError('email') }}</small>
        </div>
        <div class="form-group mb-2">
          <label>Username</label>
          <input v-model="username" type="text" class="form-control" :class="{ 'is-invalid': hasProfileError('username') }" />
          <small v-if="hasProfileError('username')" class="text-danger">{{ profileError('username') }}</small>
        </div>
        <div class="form-group mb-2">
          <label>Role</label>
          <b-form-select v-model="role" :options="roles" class="mb-3 form-control" value-field="id" text-field="name" :disabled="isEditingSelf" :class="{ 'is-invalid': hasProfileError('role') }"></b-form-select>
          <small v-if="isEditingSelf" class="text-muted">You can update your profile details here, but your role stays unchanged.</small>
          <small v-if="hasProfileError('role')" class="text-danger d-block">{{ profileError('role') }}</small>
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-user')" >Close</b-button>
          <b-button type="submit" :disabled="savingProfile" class="btn ms-1 w-30" variant="primary" >
            <b-spinner v-if="savingProfile" small class="align-middle me-1"></b-spinner>
            <i v-else class="fas fa-check-circle"></i>
            {{ savingProfile ? 'Saving...' : 'Submit' }}
          </b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="change-user" centered :title="isPasswordSelfService ? 'Change My Password' : 'Change User Password'" title-class="font-18" hide-footer>
      <form @submit.prevent="editUserPassword">
        <input v-model="id" type="hidden">
        <div class="mb-2">
          <small class="text-muted">
            <span v-if="isPasswordSelfService">Update your password using your current password and a strong new password.</span>
            <span v-else>Set a new password for <b>{{ fullname }}</b>. They will receive an email confirming the password was changed.</span>
          </small>
        </div>
        <div v-if="isPasswordSelfService" class="form-group mb-2">
          <label>Old Password</label>
          <input v-model="oldPassword" type="password" class="form-control" :class="{ 'is-invalid': hasPasswordError('old_password') }" />
          <small v-if="hasPasswordError('old_password')" class="text-danger">{{ passwordError('old_password') }}</small>
        </div>
        <div class="form-group mb-2">
          <label>New Password</label>
          <input v-model="newPassword" type="password" class="form-control" :class="{ 'is-invalid': hasPasswordError('new_password') }" />
          <small class="d-block" :class="passwordStrengthClass">{{ passwordStrengthText }}</small>
          <small v-if="hasPasswordError('new_password')" class="text-danger d-block">{{ passwordError('new_password') }}</small>
        </div>
        <div class="form-group mb-2">
          <label>Confirm New Password</label>
          <input v-model="confirmPassword" type="password" class="form-control" :class="{ 'is-invalid': hasPasswordError('new_password') || passwordMismatch }" />
          <small v-if="passwordMismatch" class="text-danger">New password confirmation does not match.</small>
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('change-user')" >Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary" :disabled="savingPassword" >
            <b-spinner v-if="savingPassword" small class="align-middle me-1"></b-spinner>
            <i v-else class="fas fa-check-circle"></i>
            {{ savingPassword ? 'Saving...' : 'Submit' }}
          </b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="delete-user" centered title="Delete System User" title-class="font-18" hide-footer>
      <form @submit.prevent="removeUser">
        <input v-model="id" type="hidden">
        Are you sure you want to delete the User : <b>{{ fullname }}</b> ?
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-user')" >Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary" :disabled="deletingUser" >
            <b-spinner v-if="deletingUser" small class="align-middle me-1"></b-spinner>
            <i v-else class="fas fa-check-circle"></i>
            {{ deletingUser ? 'Submitting...' : 'Submit' }}
          </b-button>
        </div>
      </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { userMethods, userComputed,roleMethods, roleComputed } from "@/state/helpers";

export default {
  page: {
    title: "System Users",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "System Users",
      items: [ {text: "Dashboard",to: "/",}, {text: "System Users",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'full_name', label: 'Full Name', visible: true },
          { key: 'contact', label: 'Contact', visible: true },
          { key: 'email_address', label: 'Email address', visible: true },
          { key: 'username', label: 'Username', visible: true },
          { key: 'role', label: 'Role', visible: true },
          { key: 'roleId', label: 'RoleId', visible: false },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      id:'',
      fullname:'',
      contact:'',
      email:'',
      username:'',
      password:'',
      role:'',
      usernameerror:'',
      btnuser:false,
      passStrength:'',
      originalUsername:'',
      isEditingSelf:false,
      isPasswordSelfService:false,
      oldPassword:'',
      newPassword:'',
      confirmPassword:'',
      profileErrors:{},
      passwordErrors:{},
      savingNewUser:false,
      savingProfile:false,
      savingPassword:false,
      deletingUser:false,
    };
  },
  computed: {
    ...userComputed,
    ...roleComputed,
    List() { return this.users.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.users.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.users.length>0) { a=false;} else { a=true;} return a },
    passwordMismatch() {
      return this.confirmPassword !== '' && this.newPassword !== this.confirmPassword;
    },
    passwordStrengthText() {
      if (!this.newPassword) {
        return 'Use at least 8 characters with uppercase, lowercase, number, and special character.';
      }
      if (this.isStrongPassword(this.newPassword)) {
        return 'Strong password';
      }
      return 'Password must include uppercase, lowercase, number, and special character.';
    },
    passwordStrengthClass() {
      if (!this.newPassword) {
        return 'text-muted';
      }
      return this.isStrongPassword(this.newPassword) ? 'text-success' : 'text-danger';
    },
  },
  mounted() {
    this.fetchUsers();
    this.fetchRoles();
    this.TotalRows = this.users.length;
    this.isBusy=false;
  },
  methods: {
    ...userMethods,
    ...roleMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    isOwnProfile(item) {
      return item.username === this.userData.username;
    },
    resetSharedFormFields() {
      this.id = '';
      this.fullname = '';
      this.contact = '';
      this.email = '';
      this.username = '';
      this.password = '';
      this.role = '';
      this.usernameerror = '';
      this.btnuser = false;
      this.passStrength = '';
      this.originalUsername = '';
      this.profileErrors = {};
    },
    resetPasswordForm() {
      this.passwordErrors = {};
      this.oldPassword = '';
      this.newPassword = '';
      this.confirmPassword = '';
      this.savingPassword = false;
    },
    hasProfileError(field) {
      return !!this.profileErrors[field];
    },
    profileError(field) {
      const value = this.profileErrors[field];
      return Array.isArray(value) ? value[0] : value;
    },
    hasPasswordError(field) {
      return !!this.passwordErrors[field];
    },
    passwordError(field) {
      const value = this.passwordErrors[field];
      return Array.isArray(value) ? value[0] : value;
    },
    openEdit(item){
      this.profileErrors = {};
      this.id=item.id;
      this.fullname=item.full_name;
      this.contact=item.contact;
      this.email=item.email_address;
      this.username=item.username;
      this.originalUsername=item.username;
      this.role=item.role.id;
      this.isEditingSelf = this.isOwnProfile(item);
      this.$bvModal.show('edit-user')
    },
    openPasswordChange(item){
      this.id=item.id;
      this.fullname=item.full_name;
      this.isPasswordSelfService = this.isOwnProfile(item);
      this.resetPasswordForm();
      this.$bvModal.show('change-user')
    },
    remove(id,fullname){
      this.id=id;
      this.fullname=fullname;
      this.$bvModal.show('delete-user')
    },
    isStrongPassword(value) {
      return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/.test(value || '');
    },
    async CheckPassword(){
      if (!this.password) {
        this.passStrength='';
        this.btnuser=false;
        return;
      }
      if (!this.isStrongPassword(this.password)) {
        this.passStrength='<i class="text-danger small">Weak password</i>';
        this.btnuser=true;
      } else {
        this.passStrength='<i class="text-primary small">Strong password</i>';
        this.btnuser=false;
      }
    },
    async CheckUsername(){
      if (!this.username) {
        this.usernameerror="";
        this.btnuser=false;
        return;
      }
      if (this.originalUsername && this.username === this.originalUsername) {
        this.usernameerror="";
        this.btnuser=false;
        return;
      }
      let formData = new FormData();
      formData.append("username", this.username);
      let url = "/checkusername";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          if (response.data==1) {
            this.usernameerror='<i class="text-danger small">Username Already Taken</i>';
            this.btnuser=true;
          }else{
            this.usernameerror="";
            this.btnuser=false;
          }
        }
      });
    },
    async addUser() {
      this.savingNewUser = true;
      let formData = new FormData();
      formData.append("fullname", this.fullname);
      formData.append("contact", this.contact);
      formData.append("email", this.email);
      formData.append("username", this.username);
      formData.append("password", this.password);
      formData.append("role", this.role);
      let url = "/addsystemuser";
      try {
        const response = await axios.post(url, formData);
        if (response.status == 200) {
          this.fetchUsers();
          this.$bvModal.hide('new-user');
          this.resetSharedFormFields();
          this.$toast.success(response.data.message || "User added successfully.");
        }
      } catch (error) {
        this.$toast.error(error.response?.data?.message || "Failed to add user.");
      } finally {
        this.savingNewUser = false;
      }
    },
    async editUserPassword(){
      this.passwordErrors = {};
      if (!this.isStrongPassword(this.newPassword)) {
        this.passwordErrors = { new_password: ['New password must include uppercase, lowercase, number, and special character.'] };
        return;
      }
      if (this.passwordMismatch) {
        this.passwordErrors = { new_password: ['New password confirmation does not match.'] };
        return;
      }
      let formData = new FormData();
      formData.append("id", this.id);
      if (this.isPasswordSelfService) {
        formData.append("old_password", this.oldPassword);
      }
      formData.append("new_password", this.newPassword);
      formData.append("new_password_confirmation", this.confirmPassword);
      let url = "/updateserpassword";
      this.savingPassword = true;
      try {
        const response = await axios.post(url, formData);
        if (response.status == 200) {
          this.fetchUsers();
          this.$bvModal.hide('change-user');
          this.resetPasswordForm();
          this.$toast.success(response.data.message || "Password updated successfully.");
        }
      } catch (error) {
        if (error.response?.status === 422) {
          this.passwordErrors = error.response.data.errors || {};
        }
        this.$toast.error(error.response?.data?.message || "Failed to change password.");
      } finally {
        this.savingPassword = false;
      }
    },
    async editUser(){
      this.profileErrors = {};
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("fullname", this.fullname);
      formData.append("contact", this.contact);
      formData.append("email", this.email);
      formData.append("username", this.username);
      formData.append("role", this.role);
      let url = "/updatesystemuser";
      this.savingProfile = true;
      try {
        const response = await axios.post(url, formData);
        if (response.status == 200) {
          this.fetchUsers();
          this.$bvModal.hide('edit-user');
          this.$toast.success(response.data.message || "User profile updated successfully.");
          this.resetSharedFormFields();
        }
      } catch (error) {
        if (error.response?.status === 422) {
          this.profileErrors = error.response.data.errors || {};
        }
        this.$toast.error(error.response?.data?.message || "Failed to update user profile.");
      } finally {
        this.savingProfile = false;
      }
    },
    async removeUser() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removesystemuser";
      this.deletingUser = true;
      try {
        const response = await axios.post(url, formData);
        if (response.status == 200) {
          this.fetchUsers();
          this.$bvModal.hide('delete-user');
          this.$toast.success("User deleted successfully.");
        }
      } catch (error) {
        this.$toast.error(error.response?.data?.message || "Failed to delete user.");
      } finally {
        this.deletingUser = false;
      }
    },
  },
};
</script>
